// extracted by mini-css-extract-plugin
module.exports = {"appointmentCardContainer":"AppointmentCard_appointmentCardContainer__LTkK2","acDateBig":"AppointmentCard_acDateBig__2B7Lc","acContent":"AppointmentCard_acContent__36nzR"};